import { OrderSummaryListLayoutResult } from './use-order-summary-list-layout-types';

export const useOrderSummaryListLayout = (): OrderSummaryListLayoutResult => {
  return {
    showPageFooter: true,
  };
};
